export const openingDate=new Date(2020,7,1);

export const timeInterval: any[]=[
  {dayName: 'Montag',
    dayOfWeek: 1,
    times: [
      {from: '08:00', to: '12:30'},
      {from: '15:00', to: '17:30'},
    ]},
  {dayName: 'Dienstag',
    dayOfWeek: 2,
    times: [
      {from: '08:00', to: '12:30'},
      {from: '15:00', to: '17:30'},
    ]},
  {dayName: 'Mittwoch',
    dayOfWeek: 3,
    times: [
      {from: '08:00', to: '12:30'},
    ]},
  {dayName: 'Donnerstag',
    dayOfWeek: 4,
    times: [
      {from: '08:00', to: '12:30'},
      {from: '15:00', to: '17:30'},
    ]},
  {dayName: 'Freitag',
    dayOfWeek: 5,
    times: [
      {from: '08:00', to: '12:30'}
    ]}
];
